import React from 'react'
import Topsec from '../../Component/Faq/Topsec'
import Investment from '../../Component/Faq/Investment'
import Savings from '../../Component/Faq/Savings'
import AssetsF from '../../Component/Faq/Assets'
import Seo from '../../Component/Seo'

function Faq() {
  return (
    <div>
      <Seo
        title='Halal Wealth FAQ | Savings, Investment and Financing Help'
        description='Find answers about halal savings, investment pods, asset financing, onboarding, and security. Get clear support from the Halal Wealth FAQ.'
        pathname='/faq'
      />
      <Topsec/>
      <Investment/>
      <Savings/>
      <AssetsF/>
    </div>
  )
}

export default Faq
